import { ArchiveIcon } from "@phosphor-icons/react/dist/csr/Archive";
import { CodeIcon } from "@phosphor-icons/react/dist/csr/Code";
import { FileIcon } from "@phosphor-icons/react/dist/csr/File";
import { FileTextIcon } from "@phosphor-icons/react/dist/csr/FileText";
import { ImageIcon } from "@phosphor-icons/react/dist/csr/Image";
import { TableIcon } from "@phosphor-icons/react/dist/csr/Table";
import { FILE_KIND, fileKindFor } from "./document-utils";

// What a customer sends is a mixed bag: phone photos of a plan on the wall, a payroll
// register as a PDF, exports as CSV or XLSX, the odd JSON dump. A row of identical page
// icons makes that list harder to scan than it needs to be.
const KIND_ICON = {
  [FILE_KIND.image]: ImageIcon,
  [FILE_KIND.table]: TableIcon,
  [FILE_KIND.document]: FileTextIcon,
  [FILE_KIND.code]: CodeIcon,
  [FILE_KIND.archive]: ArchiveIcon,
  [FILE_KIND.file]: FileIcon,
} as const;

export const DocumentIconFor = ({
  contentType,
  fileName,
  className,
}: {
  contentType?: string | null;
  fileName?: string | null;
  className?: string;
}) => {
  const kind = fileKindFor(contentType, fileName);
  const Icon = KIND_ICON[kind];

  return <Icon data-file-kind={kind} className={className} />;
};
